/* eslint import/no-extraneous-dependencies: 0 */
/* eslint object-shorthand: 0 */
/* eslint func-names: 0 */
/* eslint max-len: 0 */
import * as Blockly from 'blockly';
import colors from '../utils/colors';
import options from '../utils/blocksOptions';

Blockly.Blocks.ciudad_reestablecer = {
  init: function () {
    this.setColour(colors.COLOUR_CONTROL);
    this.appendDummyInput('').appendField(Blockly.Msg.LANG_CIUDAD_REESTABLECER).setAlign(Blockly.inputs.Align.RIGHT);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_CIUDAD_REESTABLECER_TOOLTIP);
  },
};

Blockly.Blocks.luces_ciudad = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput('image')
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/Luz_calle.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput().setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        [Blockly.Msg.LANG_SALIDAS_LED_ON, 'LOW'],
        [Blockly.Msg.LANG_SALIDAS_LED_OFF, 'HIGH'],
      ]), 'STAT');
    this.appendDummyInput().appendField(Blockly.Msg.LANG_SALIDAS_LUCES_CIUDAD).setAlign(Blockly.inputs.Align.RIGHT)
      .appendField(new Blockly.FieldDropdown([
        ['Zona 1', '1'],
        ['Zona 2', '2'],
        ['Zona 3', '3'],
        ['Zona 4', '4'],
        ['Zona 5', '5'],
      ]), 'ZONA');
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip(Blockly.Msg.LANG_SALIDAS_LUCES_CIUDAD_TOOLTIP);
  },
};

Blockly.Blocks.luces_colon = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/teatroColon.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('COLOUR')
      .appendField(Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL_LED)
      .appendField(new Blockly.FieldDropdown([
        ['Teatro Colón 1', '0'],
        ['Teatro Colón 2', '4'],
        ['Teatro Colón 3', '8'],
        ['Teatro Colón 4', '12'],
      ]), 'LED')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip('Enciende las luces del Teatro Colón');
  },
};

Blockly.Blocks.luces_colon_off = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/teatroColon.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL_CLEAR)
      .appendField(new Blockly.FieldDropdown([
        ['Teatro Colón 1', '0'],
        ['Teatro Colón 2', '4'],
        ['Teatro Colón 3', '8'],
        ['Teatro Colón 4', '12'],
      ]), 'LED')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip('Apaga las luces del Teatro Colón');
  },
};

Blockly.Blocks.luces_obelisco = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/obelisco.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendValueInput('COLOUR')
      .appendField(Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL)
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL_LED)
      .appendField(new Blockly.FieldDropdown([
        ['Obelisco 1', '0'],
        ['Obelisco 2', '1'],
        ['Obelisco 3', '2'],
        ['Obelisco 4', '3'],
      ]), 'LED')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip('Enciende las luces del Obelisco');
  },
};

Blockly.Blocks.luces_obelisco_off = {
  init: function () {
    this.setColour(colors.COLOUR_SALIDAS);
    this.appendDummyInput()
      .appendField(new Blockly.FieldImage(`${options.imgBase}/blocks/unoMega/obelisco.png`, options.blockWidth, options.blockHeight))
      .appendField(Blockly.Msg.LANG_SALIDAS_RAYITA);
    this.appendDummyInput('')
      .appendField(Blockly.Msg.LANG_BHOOT_LED_NEOPIXEL_CLEAR)
      .appendField(new Blockly.FieldDropdown([
        ['Obelisco 1', '0'],
        ['Obelisco 2', '1'],
        ['Obelisco 3', '2'],
        ['Obelisco 4', '3'],
      ]), 'LED')
      .setAlign(Blockly.inputs.Align.RIGHT);
    this.setInputsInline(true);
    this.setPreviousStatement(true, null);
    this.setNextStatement(true, null);
    this.setTooltip('Apaga las luces del Obelisco');
  },
};
